module.exports = __webpack_public_path__ + "static/media/step-mobile-4.7cc0a5e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/stepper-how-it-works/step-mobile-4.png
// module id = 2217
// module chunks = 0